<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail2="true"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="Nama Metode Pembayaran"
                invalid-feedback="Payment method name should be filled"
                required
                v-model="$v.paymentMethodForm.name.$model"
                :is-valid="!$v.paymentMethodForm.name.$invalid"
              />
            </CCol>

            <CCol sm="3">
              <CInput
                label="Account Number"
                invalid-feedback="Account number should be filled"
                required
                v-model="$v.paymentMethodForm.account_number.$model"
                :is-valid="!$v.paymentMethodForm.account_number.$invalid"
              />
            </CCol>

          

          </CRow>

          <CRow>

             <CCol sm="3">
              <CSelect
                label="Payment Channel"
                invalid-feedback="Please select Payment Channel"
                :options="channelOptions"
                required
                placeholder="Please Select one"
                :value.sync="$v.paymentMethodForm.payment_channel.$model"
                :is-valid="!$v.paymentMethodForm.payment_channel.$invalid"
              />
            </CCol>

            <CCol sm="3">
              <CSelect
                label="Group"
                invalid-feedback="Please select group"
                :options="groupOptions"
                required
                placeholder="Please Select one"
                :value.sync="$v.paymentMethodForm.group.$model"
                :is-valid="!$v.paymentMethodForm.group.$invalid"
              />
            </CCol>

          </CRow>

          <CRow>

            <CCol sm="3">
              <CInput
                label="Ordering"
                invalid-feedback="Ordering should be filled"
                required
                v-model="$v.paymentMethodForm.ordering.$model"
                :is-valid="!$v.paymentMethodForm.ordering.$invalid"
              />
            </CCol>

          </CRow>

           <CRow>
             <CCol sm="3">
                <CTextarea
                  required
                  rows="4"
                  label="Description"
                  invalid-feedback="Description should be filled"
                  v-model="$v.paymentMethodForm.description.$model"
                  :is-valid="!$v.paymentMethodForm.description.$invalid"
                />
              </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.paymentMethodForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

export default {
  name: "PaymentMethod",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Payment Method",
      fields: [
        { key: "name", label: "Metode Pembayaran", sorter: true },
        { key: "account_number", label: "Nomor Akun", sorter: true },
        { key: "payment_channel", label: "Payment Channel", sorter: true },
        { key: "group", label: "Group", sorter: true },
        { key: "ordering", label: "Ordering", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      options: [
        { value: "1", label: "Aktif" },
        { value: "2", label: "Non Aktif" },
      ],
      groupOptions:[
        { value: "1", label: "Virtual Account" },
        { value: "2", label: "E-Money" },
        { value: "3", label: "Store" },
        { value: "4", label: "Credit Card" },
        { value: "5", label: "Cash On Delivery" },
        { value: "6", label: "Pay Later" },
      ],
      channelOptions: [
        { value: "02", label: "Mandiri ClickPay" },
        { value: "03", label: "KlikBCA" },
        { value: "04", label: "DOKU Wallet" },
        { value: "06", label: "BRI e-Pay" },
        { value: "15", label: "Credit Card" },
        { value: "16", label: "Credit Card Tokenization" },
        { value: "17", label: "Recurring Payment" },
        { value: "18", label: "BCA KlikPay" },
        { value: "19", label: "CIMB Clicks" },
        { value: "22", label: "Sinarmas VA" },
        { value: "23", label: "MOTO" },
        { value: "25", label: "Muamalat Internet Banking" },
        { value: "26", label: "Danamon Internet Banking" },
        { value: "28", label: "Permata Internet Banking" },
        { value: "29", label: "BCA VA" },
        { value: "31", label: "Indomaret" },
        { value: "32", label: "CIMB VA" },
        { value: "33", label: "Danamon VA" },
        { value: "34", label: "BRI VA" },
        { value: "35", label: "Alfa VA" },
        { value: "36", label: "Permata VA" },
        { value: "37", label: "Kredivo" },
        { value: "38", label: "BNI VA" },
        { value: "39", label: "Linepay ECash" },
        { value: "41", label: "Mandiri VA" },
        { value: "42", label: "QNB VA" },
        { value: "43", label: "BTN VA" },
        { value: "44", label: "Maybank VA" },
        { value: "45", label: "BNI Yap!" },
        { value: "47", label: "Arta Jasa VA" },
      ],
      items: [],
      paymentMethodForm: tableInterfaces.payment_method,
      isLoading: false,
      addButton: false,
      isEdit: false,
    };
  },
  validations: {
    paymentMethodForm: {
      name: { required },
      account_number: { required },
      payment_channel: {required},
      ordering: {required},
      group:{required},
      description: {required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getPaymentMethod();
    },
    getPaymentMethod: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/payment_method/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.paymentMethodForm = item;
    },
    resetForm: function () {
      this.isEdit = false;
      for (var i in tableInterfaces.payment_method) {
        tableInterfaces.payment_method[i] = null;
      }
      this.paymentMethodForm = tableInterfaces.payment_method;
    },
    submitForm: function (event) {
      event.preventDefault();
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/payment_method/add", this.paymentMethodForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
